import { readViewportIsPortrait, readViewportCssDimensions, subscribeViewportChange } from '@renderer/utils/viewportMetrics'
import { useEffect, useMemo, useState } from 'react'

/**
 * Physical viewport orientation and size (no CSS rotation / letterboxing).
 * Used to pick portrait vs landscape project layouts at runtime.
 */
export function useDeviceOrientation(): {
  isPortrait: boolean
  isLandscape: boolean
  viewportWidth: number
  viewportHeight: number
} {
  const [tick, setTick] = useState(0)

  useEffect(() => {
    const bump = (): void => setTick((t) => t + 1)
    return subscribeViewportChange(bump)
  }, [])

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- tick triggers recompute
  void tick

  return useMemo(() => {
    const { width: vw, height: vh } = readViewportCssDimensions()
    const isPortrait = readViewportIsPortrait()
    return {
      viewportWidth: vw,
      viewportHeight: vh,
      isPortrait,
      isLandscape: !isPortrait
    }
  }, [tick])
}
